import { ChangeEvent, FormEvent, MouseEvent } from 'react';
import { User } from 'state/user/UserTypes';
import { ValueType, ActionMeta } from 'react-select';

/**
 * FORM/CLICK EVENTS
 */

export type ButtonClickEvent<E = HTMLButtonElement> = (E: MouseEvent<E>) => void;
export type AnchorClickEvent<E = HTMLAnchorElement> = (E: MouseEvent<E>) => void;
export type FormSubmission = FormEvent<HTMLFormElement>;
export type InputChange<T = HTMLInputElement> = ChangeEvent<T>;
export type SelectChange = ChangeEvent<HTMLSelectElement>;
export type TextAreaChange = ChangeEvent<HTMLTextAreaElement>;
export type ButtonClick = MouseEvent<HTMLButtonElement>;

//custom type for react=select
export type ReactSelectChangeEvent = (
    value: ValueType<ReactSelectOption, boolean>,
    actionMeta: ActionMeta<{}>
) => void;
export type ReactSelectOption = { label: string; value: string };
export type ReactSelectValue = ValueType<ReactSelectOption, boolean>;

export type ValueOf<T> = T[keyof T];
/**
 * AUTH
 */
export enum ErrorCodes {
    //400
    BAD_USERNAME = 'BAD_USERNAME',
    SHORT_PASSWORD = 'SHORT_PASSWORD',
    NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
    CODE_MISMATCH = 'CODE_MISMATCH',
    EXPIRED_CODE = 'EXPIRED_CODE',
    DATA_VALIDATION_ERROR = 'DATA_VALIDATION_ERROR',
    DUPLICATE_ERROR = 'DUPLICATE_ERROR',
    INVALID_REFRESH_TOKEN = 'INVALID_REFRESH_TOKEN',
    INVALID_OBJECT_ID = 'INVALID_OBJECT_ID',
    //401
    INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
    //403
    UNAUTHORIZED = 'UNAUTHORIZED',
    SUBSCRIPTION_REQUIRED = 'SUBSCRIPTION_REQUIRED',
    //404
    NO_RESULTS_ERROR = 'NO_RESULTS_ERROR',
    //500
    INTERNAL_ERROR = 'INTERNAL_ERROR',
    DATABASE_ERROR = 'DATABASE_ERROR',
}

export interface JWT {
    authToken: string;
    expiresIn: number;
    refreshToken: string;
}

export type FetchRequest<T, E = unknown> = { fetching: boolean; data: T; error: E | null };

export type Error = { code: string; message: string };

export interface LoginResponse {
    jwt: JWT;
    user: User | null;
}

export interface LoginRequest extends Partial<SignUpRequest> {
    newPassword?: string;
}

export interface ForgotPasswordRequest {
    username: string;
}

//empty object
export interface ForgotPasswordResponse {}

export interface RefreshTokenResponse {
    jwt: JWT;
}

/**
 * VERIFICATION
 */
export interface VerificationRequest {
    attribute: 'email'; // eventually will be email or phone
}

export interface VerificationResponse {
    message: string;
}

export interface ChangePasswordRequest {
    password: string;
    newPassword: string; // must be a minimum of 8 characters long
}

export interface ChangePasswordResponse {
    message: string;
}

export interface ConfirmVerificationRequest {
    email: string;
}

export interface ConfirmVerificationResponse {
    message: string;
}

export interface SignUpRequest {
    username: string;
    password: string;
    phone: string;
    firstName: string;
    lastName?: string;
    macAddresses?: string;
}
